import axios from "axios";
import { IUserRoleDto } from "./interfaces/IUserRoleDto";

export async function GetUserRoleList(){
    const url = `/user-roles`;
    const response = await axios.get<IUserRoleDto[]>(url);
    return response.data;
}